import { render, staticRenderFns } from "./emrInfoPanel.vue?vue&type=template&id=698e5c3b&"
import script from "./emrInfoPanel.vue?vue&type=script&lang=js&"
export * from "./emrInfoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports